import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import * as actions from '../actions/user-preferences'
import { UserPreferencesData } from "../models/user-preferences-data";
import { UserPreferencesHttpService } from "../services/user-preferences-http.service";

@Injectable()
export class UserPreferencesEffects {
constructor(
    private actions$: Actions,
    private userPreferencesService: UserPreferencesHttpService) {
  }

loadEffectiveValues$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<actions.LoadEffectiveValues>(actions.LOAD_EFFECTIVE_VALUES),
    switchMap(action => {
      return this.userPreferencesService.getUserPreferenceEffectiveValues().pipe(
        map((effectiveValues: UserPreferencesData) => new actions.LoadEffectiveValuesComplete(effectiveValues)),
        catchError(err => of(new actions.LoadEffectiveValuesError(err)))
      );
    })));
}

